export default __webpack_public_path__ + "static/media/mtn.6646a6a5.jpg";